export const FETCH_FAVOURITE_TEMPLATES_REQUEST =
  "FETCH_FAVOURITE_TEMPLATES_REQUEST";
export const FETCH_FAVOURITE_TEMPLATES_SUCCESS =
  "FETCH_FAVOURITE_TEMPLATES_SUCCESS";
export const FETCH_FAVOURITE_TEMPLATES_ERROR =
  "FETCH_FAVOURITE_TEMPLATES_ERROR";

export const TOGGLE_FAVOURITE_TEMPLATE_LOCAL =
  "TOGGLE_FAVOURITE_TEMPLATE_LOCAL";
export const TOGGLE_FAVOURITE_TEMPLATE_REQUEST =
  "TOGGLE_FAVOURITE_TEMPLATE_REQUEST";
export const TOGGLE_FAVOURITE_TEMPLATE_SUCCESS =
  "TOGGLE_FAVOURITE_TEMPLATE_SUCCESS";
export const TOGGLE_FAVOURITE_TEMPLATE_ERROR =
  "TOGGLE_FAVOURITE_TEMPLATE_ERROR";

export const ORDER_FAVOURITE_TEMPLATE_SUCCESS =
  "ORDER_FAVOURITE_TEMPLATE_SUCCESS";
